import { ACCESS_KEY_PARAM } from '@/ducks/accessKeys/constants';
import { isServerSide } from '@/helpers/isServerSide';

export const shouldDoInitiateRequest = ({ searchParams }: { searchParams: URLSearchParams }) => {
  if (searchParams.get(ACCESS_KEY_PARAM)) {
    return isServerSide() ? false : true;
  }

  return isServerSide() ? true : false;
};
